export var Labels = {
    paymentOptionDivider: 'or',
    cardHolderName: 'Name on card',
    cardNumber: 'Card number',
    cardExpiration: 'Expiration date (MM/YY)',
    cvv: 'CVV',
    continueButton: 'Continue'
};
export var FieldErrors = {
    invalidCardHolderName: "Please enter the cardholder's name.",
    invalidCreditCardNumber: 'Please enter a valid card number.',
    invalidCardBrand: 'Please enter a supported card issuer.',
    invalidExpirationDate: 'Please enter a valid expiration date.',
    invalidCvv: 'Please enter the valid CVV code.'
};
